/* tslint:disable */
/* eslint-disable */
export enum PhaseStatus {
    Open = 'OPEN',
    Completed = 'COMPLETED',
    Closed = 'CLOSED'
}
